import useSWR from 'swr'

import { fetcher } from './fetcher'

/**
 * Aplicativos aos quais o usuário concedeu acesso via OAuth.
 */

export interface OAuthGrantI {
  id: string,
  scopes: Array<string>,
  granted_at: string,
  updated_at: string,
  client: {
    client_id: string,
    client_name: string | null,
    client_uri: string | null,
    logo_uri: string | null,
    /** true só quando alguém da empresa revisou e aprovou o app */
    name_verified: boolean,
  },
}

interface ReturnI {
  data: Array<OAuthGrantI>,
  isLoading: boolean,
  isError: any,
  mutate: any,
}

const useOAuthGrants = () : ReturnI => {
  const { data, error, mutate } = useSWR<Array<OAuthGrantI>>(
    'oauth/grants',
    fetcher('GET'),
    { refreshInterval: 0 }
  )

  return {
    data: data ?? [],
    isLoading: !error && !data,
    isError: error,
    mutate
  }
}

export default useOAuthGrants
